import React, {Component} from 'react';
import $ from 'jquery';
import _HauteFire from './HauteFire';

const HauteFire = new _HauteFire();

export default class Jumeirah extends Component {
    constructor() {
        super();

        this.state = {randomImgUrl: ""};
    }

    componentDidMount() {
        $("body, html").animate({
            scrollTop: $("#secJumeirahBanner").position().top
        });

        const randomIndex = Math.floor(Math.random() * 3);
        let imgUrls = ["https://firebasestorage.googleapis.com/v0/b/haute-islands.appspot.com/o/IslandPics%2Fresized%2FBurj%20Al%20%20Arab%20Jumeirah%20-%20The%20Terrace%20-%20Twin%20Aerial%20Pink%20(1).jpg?alt=media&token=df6f147b-c3bb-482b-99b9-c6a7fa6478c1",
            "https://firebasestorage.googleapis.com/v0/b/haute-islands.appspot.com/o/IslandPics%2Fresized%2FJumeirah%20Port%20Soller%20Hotel%20_%20Spa%20-%20Infinity%20Pool%20and%20Es%20Fanals%20Restaurant_result.jpg?alt=media&token=fca05ea3-8971-44c4-8a52-7468086097ac",
            "https://firebasestorage.googleapis.com/v0/b/haute-islands.appspot.com/o/IslandPics%2Fresized%2FJumeirah%20Vittaveli%20-%20Aerial%20Southwest.jpg?alt=media&token=36630579-fece-4dc8-8f3a-2655ba38ad8c"
        ];
        this.setState({randomImgUrl: imgUrls[randomIndex]});

        HauteFire.setBanner();
        $(document).on("click", "img.img-island, .gallery-name", this.goToIslandDetails.bind(this));

        //Google Analytics
        HauteFire.hauteGoogleAnalytics();
    }

    goToIslandDetails(e) {
        const name = e.currentTarget.attributes["data-islandName"].value;
        if (name != "") {
            this.props.history.push("/island/" + name);
        }
    }

    scrollToElem(e) {
        const elemId = e.currentTarget.attributes["data-elemId"].value;
        $('html, body').animate({
            scrollTop: $("#" + elemId).offset().top
        }, 2000);
    }

    render() {
        return (<div>
                <section id="secJumeirahBanner" className="sec-banner banner parallax-party" data-parallax="scroll">
                    <img className="img-banner bannerpic"
                         src={this.state.randomImgUrl != "" ? this.state.randomImgUrl : ""}
                         alt="Jumeriah"/>
                    <div className="div-explore hautecontainer">
                        <h1>Welcome to Jumeirah hotels & resorts</h1>
                        <a className="explore-btn button" style={{cursor: 'pointer', marginTop: 10}}
                           data-elemId="explore" onClick={(e) => this.scrollToElem(e)}>explore</a>
                    </div>
                </section>

                <section className="gallery-sec party-gallery animated fadeInUp visible" data-animation="fadeInUp"
                         data-animation-delay="200" id="explore">

                    <div className="hautecontainer clearfix">
                        <div className="gallery bottom-space">
                            <figure className="gallery-img-wrap"><img className="img-island"
                                                                      src="https://firebasestorage.googleapis.com/v0/b/haute-islands.appspot.com/o/IslandPics%2Fresized%2FBurj%20Al%20%20Arab%20Jumeirah%20-%20The%20Terrace%20-%20Twin%20Aerial%20Pink%20(1).jpg?alt=media&amp;token=df6f147b-c3bb-482b-99b9-c6a7fa6478c1"
                                                                      alt="Burj Al Arab" data-islandname="Burj Al Arab"
                                                                      style={{height: 300, cursor: 'pointer'}}/>
                            </figure>
                            <div className="gallery-info clearfix"><span className="gallery-name"
                                                                         data-islandname="Burj Al Arab"
                                                                         style={{cursor: 'pointer'}}>Burj Al Arab<span
                                className="gallery-fig-name">, Dubai - UAE</span></span>
                            </div>
                        </div>

                        <div className="gallery bottom-space">
                            <figure className="gallery-img-wrap"><img className="img-island"
                                                                      src="https://firebasestorage.googleapis.com/v0/b/haute-islands.appspot.com/o/IslandPics%2Fresized%2FJumeirah%20Port%20Soller%20Hotel%20_%20Spa%20-%20Infinity%20Pool%20and%20Es%20Fanals%20Restaurant_result.jpg?alt=media&token=fca05ea3-8971-44c4-8a52-7468086097ac"
                                                                      alt="Jumeirah Port Soller Hotel & Spa"
                                                                      data-islandname="Jumeirah Port Soller Hotel & Spa"
                                                                      style={{height: 300, cursor: 'pointer'}}/>
                            </figure>
                            <div className="gallery-info clearfix"><span className="gallery-name"
                                                                         data-islandname="Jumeirah Port Soller Hotel & Spa"
                                                                         style={{cursor: 'pointer'}}>Jumeirah Port Soller Hotel & Spa<span
                                className="gallery-fig-name">, Spain</span></span>
                            </div>
                        </div>

                        <div className="gallery bottom-space">
                            <figure className="gallery-img-wrap"><img className="img-island"
                                                                      src="https://firebasestorage.googleapis.com/v0/b/haute-islands.appspot.com/o/IslandPics%2Fresized%2FJumeirah%20Vittaveli%20-%20Aerial%20Southwest.jpg?alt=media&token=36630579-fece-4dc8-8f3a-2655ba38ad8c"
                                                                      alt="Jumeirah Vittaveli"
                                                                      data-islandname="Jumeirah Vittaveli"
                                                                      style={{height: 300, cursor: 'pointer'}}/>
                            </figure>
                            <div className="gallery-info clearfix"><span className="gallery-name"
                                                                         data-islandname="Jumeirah Vittaveli"
                                                                         style={{cursor: 'pointer'}}>Jumeirah Vittaveli<span
                                className="gallery-fig-name">, Maldives</span></span>
                            </div>
                        </div>
                    </div>


                </section>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Jumeirah.js